import { FC } from 'react';
import Dialog from 'components/common/Dialog/Dialog';
import { useMutation } from '@apollo/client';
import { REVERT_CUSTOM_PARSER } from '../queries';
import '../styles.scss';
import { ParserAndDeselect } from '../types';

type RevertChangesDialogProps = {
  revertChangesDialogIsOpen: boolean;
  setRevertChangesDialogIsOpen: (isOpen: boolean) => void;
  refetchData: () => void;
} & ParserAndDeselect;

/**
 *
 * A dialog that performing request for revert changes performed on built-in Parser
 *
 */
const RevertChangesDialog: FC<RevertChangesDialogProps> = ({
  selectedParser,
  deselectParser,
  revertChangesDialogIsOpen,
  setRevertChangesDialogIsOpen,
  refetchData,
}: RevertChangesDialogProps) => {
  const [revertCustomChanges] = useMutation(REVERT_CUSTOM_PARSER, {
    onCompleted: () => {
      refetchData();
    },
  });

  const onClose = (): void => {
    setRevertChangesDialogIsOpen(false);
    deselectParser();
  };

  const onSubmit = (): void => {
    deselectParser();
    revertCustomChanges({
      variables: {
        id: selectedParser,
      },
    });
  };
  return (
    <Dialog
      okCallback={onSubmit}
      close={onClose}
      title="Confirm"
      className="ParsersPage__Modal"
      show={revertChangesDialogIsOpen}
    >
      Are you sure you want to revert your customizations to
      {`"${selectedParser}"`}? This operation cannot be undone.
    </Dialog>
  );
};

export default RevertChangesDialog;
